import { TabsContent } from "components/ui/tabs";
import { useFormContext, useWatch } from "react-hook-form";
import { FilterTabs } from "hooks/search/types";
import { useTranslation } from "react-i18next";
import { StyledTabs, type StyledTabItem } from "components/StyledTabs";
import { SpecificDateFilter } from "./SpecificDateFilter";
import { DateRangeFilter } from "./DateRangeFilter";

export const DateFilter = ({ name }: { name: string }) => {
  const { t } = useTranslation(["books"]);
  const { setValue } = useFormContext();

  const currentTab = useWatch({ name: `filters.${name}.tab` });
  const currentRange = useWatch({ name: `filters.${name}.range` }) || {
    from: "",
    to: "",
  };

  const handleTabChange = (value: FilterTabs) => {
    setValue(`filters.${name}.tab`, value);
    if (value === FilterTabs.SPECIFIC && currentRange.from) {
      setValue(`filters.${name}.range`, {
        from: currentRange.from,
        to: currentRange.from,
      });
    }
  };

  const tabs: StyledTabItem<FilterTabs>[] = [
    {
      value: FilterTabs.SPECIFIC,
      label: t("books:filters.dateFilter.specific"),
    },
    { value: FilterTabs.RANGE, label: t("books:filters.dateFilter.range") },
  ];

  return (
    <StyledTabs<FilterTabs>
      variant="underline"
      activeTab={currentTab}
      onTabChange={handleTabChange}
      tabs={tabs}
      listClassName="h-12 w-[calc(100%+1rem)] -translate-x-1 -translate-y-1 items-end justify-start bg-secondary-25 border-b border-secondary-100"
    >
      <TabsContent value={FilterTabs.SPECIFIC}>
        <SpecificDateFilter name={name} />
      </TabsContent>
      <TabsContent value={FilterTabs.RANGE}>
        <DateRangeFilter name={name} />
      </TabsContent>
    </StyledTabs>
  );
};
